import { render, staticRenderFns } from "./RiskAssessmentStep.vue?vue&type=template&id=902b09ba&scoped=true"
import script from "./RiskAssessmentStep.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentStep.vue?vue&type=script&lang=js"
import style0 from "./RiskAssessmentStep.vue?vue&type=style&index=0&id=902b09ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902b09ba",
  null
  
)

export default component.exports